<template>
  <Multiselect :no-results-text="i18n.t('Nebyly nalezeny žádné výsledky')" :strict="false" :close-on-deselect="true" :close-on-select="true" :searchable="true" :can-clear="true" :canDeselect="false" :options="props.options" :label="props.labelField" :valueProp="props.valueField" v-model="props.modelValue" :placeholder="props.placeholder" @select="emit('update:modelValue', $event)" />
</template>
<script setup>

import Multiselect from '@vueform/multiselect';
import "assets/css/dropDown.scss";

const props = defineProps({
  modelValue: Object,
  options: Array,
  labelField: String,
  valueField: String,
  placeholder: String,
});

const i18n = useI18n();

const emit = defineEmits(['update:modelValue']);

</script>